import React from 'react';
import styles from './BudgetDropdown.module.scss';

export function BudgetDropdown({budgets, budget, onBudgetChange}){
    return (
        <div className={styles.actions}>
            {
                budgets 
                ? <Budgets budgets={budgets} budget={budget} onBudgetChange={onBudgetChange} />
                : <LoadingBudget />
            }

        </div>
    );
}

function LoadingBudget(){
    return (
        <div className={styles.actionBudgetLoader}>
            <img src='/gif/loading.gif' alt='waiting for budget to load' />
            <p>Loading your budgets...</p>
        </div>
    );
}

function Budgets({budgets, budget, onBudgetChange}){
    const budgetId = budget ? budget.id : '';
    return (
        <div className={styles.optionDropdown}>
            <img src="/Vector.png" alt="search" className="logo"/>
            <select className={styles.budgetsDropdown} id="budgets-dropdown" value={budgetId} onChange={(e) => onBudgetChange(e)}>
                <option value="" disabled>Select a budget...</option>
                {budgets.map((budget) => (
                    <option key={budget.id} value={budget.id}>
                    {budget.name}
                    </option>
                ))}
                </select>
        </div>
    );
}